<div *ngIf="active" class="spinner-container" [@flyInOut]="active" fxLayout="row" fxLayoutAlign="center center">
    <app-kd-logo-loading fxHide.gt-sm size="small"></app-kd-logo-loading>
    <app-kd-logo-loading fxHide.lt-md></app-kd-logo-loading>
</div>

